import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Button from '../../components/buttons/Button';
// import Insurances from '../../components/insurances/Insurances';
// import Authorizations from '../../components/authorizations/Authorizations';
// import Attachments from '../../components/attachments/Attachments';
import { getApiLink } from './../../services/getApiLink';
import lawForms from './../../static-data/law-forms.json';
import proffessions from './../../static-data/professions.json';
import arrow from './../../images/arrow.svg';
import loading from './../../images/loading-white-ico.svg'
import StepBar from '../../components/steps-bar/StepsBar';
import LeasingRateResult from '../../components/leasing-rate/LeasingRateResult';
import Heading from '../../components/heading/Heading';
// import drawPDF from './../../services/drawPDF';
import { convertPrice } from '../../services/convertPrice';
import ModalLastStep from './../../components/static-modals/ModalLastStep';
import ButtonsNav from './../../components/buttons-nav/ButtonsNav';
import { useNavigate } from "react-router";
import Attachments from './../../components/attachments/Attachments';
import { fetchPdfAsBase64 } from './../../services/pdfToBase64';

const StepSix = ( props ) => {
    let [ load, setLoad ] = useState(false);
    let [ forceValidate, setForceValidate ] = useState(false);
    let [ disabledButton, setDisabledButton ] = useState(false);
    let [ buttonText, setButtonText ] = useState('ZAPISZ I ZŁÓŻ WNIOSEK');
    let [ finishLoading, setFinishLoading ] = useState(false);
    let [ modal, setModal ] = useState(false);

    const dispatch = useDispatch()
    let navigate = useNavigate();

    let factor              = useSelector(state => state.factor)
    let tableNameWP         = useSelector(state => state.tableNameWP)
    let identificator       = useSelector(state => state.identificator)
    let products            = useSelector(state => state.products)
    let steps               = useSelector(state => state.steps)
    let repurchase          = useSelector(state => state.repurchase)
    let leasingTime         = useSelector(state => state.leasingTime)
    let initialCharge       = useSelector(state => state.initialCharge)
    let productPrice        = useSelector(state => state.productPrice)
    // let productPriceEnd     = useSelector(state => state.productPriceEnd)
    let activeContract      = useSelector(state => state.selectedLease)
    let tax                 = useSelector(state => state.tax)
    let selectedLease       = useSelector(state => state.selectedLease)
    let modernLease         = useSelector(state => state.modernLease)
    let finalRate           = useSelector(state => state.finalRate)
    let rateFrequency       = useSelector(state => state.rateFrequency)
    let providerPostal      = useSelector(state => state.providerPostal)
    let callNumber          = useSelector(state => state.callNumber)
    let isShop              = useSelector(state => state.isShop)
    let chargePrice         = useSelector(state => state.chargePrice)
    let minMonth            = useSelector(state => state.minMonth)
    let maxMonth            = useSelector(state => state.maxMonth)
    let providerName        = useSelector(state => state.providerName)
    let providerNip         = useSelector(state => state.providerNip)
    let fvFile              = useSelector(state => state.fvFile)
    let partnerID           = useSelector(state => state.partnerID)
    let partnerEmail        = useSelector(state => state.partnerEmail)

    // 
    let trn                     = useSelector(state => state.trn)
    let shareCapital            = useSelector(state => state.shareCapital)
    let legalForm              = useSelector(state => state.legalForm)
    let lineBusiness            = useSelector(state => state.lineBusiness)
    let revenuePresentFinancialYear = useSelector(state => state.revenuePresentFinancialYear)
    let revenueLastFinancialYear = useSelector(state => state.revenueLastFinancialYear)
    let financialCity           = useSelector(state => state.financialCity)
    let financialAddress        = useSelector(state => state.financialAddress)
    let bankCompanyName         = useSelector(state => state.bankCompanyName)
    let bankName                = useSelector(state => state.bankName)
    let bankIban                = useSelector(state => state.bankIban)
    let bankEmail               = useSelector(state => state.bankEmail)
    let additionalAddress       = useSelector(state => state.additionalAddress)
    let nip                     = useSelector(state => state.nip)
    let companyName             = useSelector(state => state.companyName)
    let companyAddress          = useSelector(state => state.companyAddress)
    let postalCustomer          = useSelector(state => state.postalCustomer)
    let city                    = useSelector(state => state.city)
    let additionalCompanyAddress          = useSelector(state => state.additionalCompanyAddress)
    let additionalPostalCustomer          = useSelector(state => state.additionalPostalCustomer)
    let additionalCity                    = useSelector(state => state.additionalCity)
    let companyStart            = useSelector(state => state.companyStart)
    let registryType            = useSelector(state => state.registryType)
    let idNumber                = useSelector(state => state.idNumber)
    let phone                   = useSelector(state => state.phone)
    let email                   = useSelector(state => state.email)
    let lawForm                 = useSelector(state => state.lawForm)
    let profession              = useSelector(state => state.profession)
    let employeesNumber         = useSelector(state => state.employeesNumber)
    let website                 = useSelector(state => state.website)
    let emailFV                 = useSelector(state => state.emailFV)
    let dataFromGUS             = useSelector(state => state.dataFromGUS)
    let bank                    = useSelector(state => state.bank)
    let bankAccount             = useSelector(state => state.bankAccount)
    let otherBankAccountCheckbox = useSelector(state => state.otherBankAccountCheckbox)
    let otherBankAccount        = useSelector(state => state.otherBankAccount)
    let consentAutomaticBankAccountCheckbox = useSelector(state => state.consentAutomaticBankAccountCheckbox) //new
    let legalRepresentative             = useSelector(state => state.legalRepresentative);
    //
    let authorizedPersons        = useSelector(state => state.authorizedPersons) // new data 

    //
    let disclaimerReg               = useSelector(state => state.disclaimerReg)
    let taxArrears                  = useSelector(state => state.taxArrears)
    let taxArrearsPrice             = useSelector(state => state.taxArrearsPrice)
    let ZUSarrears                  = useSelector(state => state.ZUSarrears)
    let ZUSarrearsPrice             = useSelector(state => state.ZUSarrearsPrice)
    let enforcementProceedings      = useSelector(state => state.enforcementProceedings)
    let enforcementProceedingsPrice = useSelector(state => state.enforcementProceedingsPrice)
    let prevYearRevenuesTwo         = useSelector(state => state.prevYearRevenuesTwo)
    let revenueOldTwo               = useSelector(state => state.revenueOldTwo)
    let revenueProfitOldTwo         = useSelector(state => state.revenueProfitOldTwo)
    let revenueScoreOldTwo          = useSelector(state => state.revenueScoreOldTwo)
    let revenueLossExplanationOldTwo = useSelector(state => state.revenueLossExplanationOldTwo)
    let prevYearRevenues            = useSelector(state => state.prevYearRevenues)
    let revenueOld                  = useSelector(state => state.revenueOld)
    let revenueScoreOld             = useSelector(state => state.revenueScoreOld)
    let revenueProfitOld            = useSelector(state => state.revenueProfitOld)
    let revenueLossExplanationOld   = useSelector(state => state.revenueLossExplanationOld)
    let revenue                     = useSelector(state => state.revenue)
    let revenueFrom                 = useSelector(state => state.revenueFrom)
    let revenueTo                   = useSelector(state => state.revenueTo)
    let revenueScore                = useSelector(state => state.revenueScore)
    let revenueProfit               = useSelector(state => state.revenueProfit)
    let revenueLossExplanation      = useSelector(state => state.revenueLossExplanation)
    let checkAndLossAmortizationOld = useSelector(state => state.checkAndLossAmortizationOld)
    let checkAndLossAmortizationTypeOld = useSelector(state => state.checkAndLossAmortizationTypeOld)
    let profitFromSalesOld = useSelector(state => state.profitFromSalesOld)
    let checkAndLossFrom = useSelector(state => state.checkAndLossFrom)
    let checkAndLossTo = useSelector(state => state.checkAndLossTo)
    let checkAndLossAmortization = useSelector(state => state.checkAndLossAmortization)
    let checkAndLossAmortizationTypeOldTwo = useSelector(state => state.checkAndLossAmortizationTypeOldTwo)
    let profitFromSales = useSelector(state => state.profitFromSales)
    let balanceFrom = useSelector(state => state.balanceFrom)
    let balanceTo = useSelector(state => state.balanceTo)
    let balanceFixedAssets = useSelector(state => state.balanceFixedAssets)
    let balanceFixedAssetsOld = useSelector(state => state.balanceFixedAssetsOld)
    let balanceTotalEquity = useSelector(state => state.balanceTotalEquity)
    let balanceTotalEquityOld = useSelector(state => state.balanceTotalEquityOld)
    let balanceBusinesslikeAndDurable = useSelector(state => state.balanceBusinesslikeAndDurable)
    let balanceBusinesslikeAndDurableOld = useSelector(state => state.balanceBusinesslikeAndDurableOld)
    let balanceCoreCapital = useSelector(state => state.balanceCoreCapital)
    let balanceCoreCapitalOld = useSelector(state => state.balanceCoreCapitalOld)
    let balanceAssets = useSelector(state => state.balanceAssets)
    let balanceAssetsOld = useSelector(state => state.balanceAssetsOld)
    let balanceLiabilitiesAndProvisions = useSelector(state => state.balanceLiabilitiesAndProvisions)
    let balanceLiabilitiesAndProvisionsOld = useSelector(state => state.balanceLiabilitiesAndProvisionsOld)
    let balanceWrestling = useSelector(state => state.balanceWrestling)
    let balanceWrestlingOld = useSelector(state => state.balanceWrestlingOld)
    let balanceLongtermLiabilities = useSelector(state => state.balanceLongtermLiabilities)
    let balanceLongtermLiabilitiesOld = useSelector(state => state.balanceLongtermLiabilitiesOld)
    let balanceShorttermReceivables = useSelector(state => state.balanceShorttermReceivables)
    let balanceShorttermReceivablesOld = useSelector(state => state.balanceShorttermReceivablesOld)
    let balanceCurrentLiabilities = useSelector(state => state.balanceCurrentLiabilities)
    let balanceCurrentLiabilitiesOld = useSelector(state => state.balanceCurrentLiabilitiesOld)
    let balanceCash = useSelector(state => state.balanceCash)
    let balanceCashOld = useSelector(state => state.balanceCashOld)
    let balanceSumOfAssetsLiabilities = useSelector(state => state.balanceSumOfAssetsLiabilities)
    let balanceSumOfAssetsLiabilitiesOld = useSelector(state => state.balanceSumOfAssetsLiabilitiesOld)
    let expiredStatus = useSelector(state => state.expiredStatus)
    let balanceObligations = useSelector(state => state.balanceObligations)
    let balanceReceivables = useSelector(state => state.balanceReceivables)
    let realEstatesCorporatePrivate = useSelector(state => state.realEstatesCorporatePrivate)
    let realEstatesMortgageEncumbered = useSelector(state => state.realEstatesMortgageEncumbered)
    let realEstatesOwnership = useSelector(state => state.realEstatesOwnership)
    let statementCreditsPaymentCheckbox = useSelector(state => state.statementCreditsPaymentCheckbox)
    let receivablesObligationsDeliveriesServicesDate = useSelector(state => state.receivablesObligationsDeliveriesServicesDate)
    let obligationsTotalPrice = useSelector(state => state.obligationsTotalPrice)
    let obligationsLastDatePay = useSelector(state => state.obligationsLastDatePay)
    let obligationsNumberCreditors = useSelector(state => state.obligationsNumberCreditors)
    let obligationsOverdueLiabilities = useSelector(state => state.obligationsOverdueLiabilities)
    let obligationsOverdueLiabilitiesOver30Days = useSelector(state => state.obligationsOverdueLiabilitiesOver30Days)
    let receivablesTotalPrice = useSelector(state => state.receivablesTotalPrice)
    let receivablesLastDatePay = useSelector(state => state.receivablesLastDatePay)
    let receivablesNumberCreditors = useSelector(state => state.receivablesNumberCreditors)
    let receivablesOverdueLiabilities = useSelector(state => state.receivablesOverdueLiabilities)
    let receivablesOverdueLiabilitiesOver30Days = useSelector(state => state.receivablesOverdueLiabilitiesOver30Days)
    let explanationReceivablesObligations = useSelector(state => state.explanationReceivablesObligations)
    let explanationLoss = useSelector(state => state.explanationLoss)

    //
    let realEstatesFiles                 = useSelector(state => state.realEstatesFiles)
    let realEstatesItems                 = useSelector(state => state.realEstatesItems)
    let fundsFiles                       = useSelector(state => state.fundsFiles)
    let fundsItems                       = useSelector(state => state.fundsItems)

    //
    let otherCreditsFiles                       = useSelector(state => state.otherCreditsFiles)
    let otherCreditsItems                       = useSelector(state => state.otherCreditsItems)
    
    //
    let authCheckOne        = useSelector(state => state.authCheckOne)
    let authName            = useSelector(state => state.authName)
    let authSurname         = useSelector(state => state.authSurname)
    let authAddress         = useSelector(state => state.authAddress)
    let authPesel           = useSelector(state => state.authPesel)
    let authId              = useSelector(state => state.authId)
    let authCheckTwo        = useSelector(state => state.authCheckTwo)
    let authCheckThree      = useSelector(state => state.authCheckThree)
    let authCheckFour       = useSelector(state => state.authCheckFour)
    let authCheckFive       = useSelector(state => state.authCheckFive)
    let authCheckSix        = useSelector(state => state.authCheckSix)
    // let authCheckSeven      = useSelector(state => state.authCheckSeven)
    // let authCheckEight      = useSelector(state => state.authCheckEight)
    let attachmentsFiles    = useSelector(state => state.attachmentsFiles)
    let comments            = useSelector(state => state.comments)
    let postman             = useSelector(state => state.postman)
    // let emailbill           = useSelector(state => state.emailbill)
    let esignPersons        = useSelector(state => state.esignPersons)
    let esign               = useSelector(state => state.esign)

    let minThreshold     = useSelector(state => state.minThreshold);
    let maxThreshold     = useSelector(state => state.maxThreshold);

    let signedFileUrl = useSelector(state => state.signedFileUrl);
    let signedFileApiUrl = useSelector(state => state.signedFileApiUrl);
    let urlFormFinish       = useSelector(state => state.urlFormFinish)
    //

    

    useEffect(() => {
        if ( !load ) {
            window.scrollTo(0, 0);
            if ( productPrice < minThreshold ) {
                dispatch({ type: 'STEPS_CHANGE', value: 5 })
            } 
            else if( productPrice >= minThreshold && productPrice < maxThreshold) {
                dispatch({ type: 'STEPS_CHANGE', value: 5 })  
            } 
            else if( productPrice >= maxThreshold) {
                dispatch({ type: 'STEPS_CHANGE', value: 5 })
            } 
            else {
                dispatch({ type: 'STEPS_CHANGE', value: 5 })
            }
            if(typeof window !== "undefined") {
                window.dataLayer.push({'event':'pageview'});
            }
            getTextBtn();
            recalculateRates();
            setLoad(true);
        } 
    }, [load])

    const getTextBtn = () => {
        if(productPrice >= maxThreshold) {
            setButtonText('ZAPISZ I ZŁÓŻ WNIOSEK');
        }else{
            setButtonText('ZŁÓŻ WNIOSEK');
        }
    }

    useEffect(() => {
        getTextBtn();
    }, [productPrice])

    const getNumberMonth = (month) => {
        if(month == "Styczeń") {
            return "01";
        }else if(month == "Luty") {
            return "02";
        }else if(month == "Marzec") {
            return "03";
        }else if(month == "Kwiecień") {
            return "04";
        }else if(month == "Maj") {
            return "05";
        }else if(month == "Czerwiec") {
            return "06";
        }else if(month == "Lipiec") {
            return "07";
        }else if(month == "Sierpień") {
            return "08";
        }else if(month == "Wrzesień") {
            return "09";
        }else if(month == "Październik") {
            return "10";
        }else if(month == "Listopad") {
            return "11";
        }else if(month == "Grudzień") {
            return "12";
        }
    }

    let searchInLawForms = (val) => {
        let key = ''
        lawForms.map( item  => {
            if ( item.val == val) {
                key = item.key;
            }
        })
        return key;
    }
    let searchInProffesions = (val) => {
        let key = ''
        proffessions.map( item  => {
            if ( item.val == val) {
                key = item.key;
            }
        })
        return key;
    }

    let reconvertPrice = (val) => {
        let valuePrice = val.replace(/ /g,'');
        valuePrice = valuePrice.replace('zł', '');
        valuePrice = valuePrice.replace(',','.');

        return(valuePrice);
    }
    

    let prev = () => {
        // let step = productPrice >= 10000.00 && productPrice < 30000.00 ? '3' : '5';
        let step = '4';
        navigate('/step/' + step);
    }
    
    let next = async() => {
        if ( !disabledButton ) {
            await setDisabledButton(true);
            await setForceValidate(true)
            await wait(300);
            let errors = await checkErrors();
            await wait(200);
            if ( !errors ) {
                await setFinishLoading( true );
                await setButtonText('Twój wniosek jest przetwarzany...')
                await wait(400);
                if ( !(finalRate.length == 0 || finalRate == 0 || finalRate == '--' || finalRate == '0 AED') ) {
                    await saveAttachments();
                } else {
                    // await setButtonText('Złóż wniosek');
                    await getTextBtn();
                    await setFinishLoading( false );
                }

                // await navigate('/thank-you');
            } else {
                // await setButtonText('Złóż wniosek');
                await getTextBtn();
                await setFinishLoading( false );
            }
            await setForceValidate(false)
            await setDisabledButton(false);
            
        }
        
    }
    let saveForm = async () => {
        dispatch({ type: 'END_PAGE_CHANGE', value: true })
        let req = new XMLHttpRequest();
        //NEW DATA EMIRATED
        let urlPDF = signedFileUrl;
        let urlAPIPDF = signedFileApiUrl;
        const base64 = await fetchPdfAsBase64(urlAPIPDF);
        let data = [
            {
                "identificator": identificator,
                "isShop": isShop,
                "products": products,
                "emailProductPrice": convertPrice(productPrice) + ' AED',
                "totalPrice": productPrice,
                "months": leasingTime,
                "finalRate": finalRate,
                "providerName": providerName,
                "rateFrequency": rateFrequency == "miesieczna" ? "monthly" : "quarterly",
                "tableNameWP": tableNameWP,
                "factor": factor,
                "urlFormFinish": urlFormFinish,
                "partnerID": partnerID,
                "partnerEmail": partnerEmail
            },
            {
                "company": companyName,
                "legalRepresentative": legalRepresentative,
                "city": city,
                "address": companyAddress,
                "additionalAddress": additionalAddress,
                "additionalCity": additionalCity,
                "additionalCompanyAddress": additionalCompanyAddress,
                "phone": phone,
                "email": email,
                "www": website,
            }, 
            {
                "representatives": authorizedPersons
            },
            {
                "trn": trn,
                "shareCapital": shareCapital,
                "legalForm": legalForm,
                "lineBusiness": lineBusiness,
                "employeesNumber": employeesNumber,
                "revenuePresentFinancialYear": revenuePresentFinancialYear,
                "revenueLastFinancialYear": revenueLastFinancialYear,
                "financialCity": financialCity,
                "financialAddress": financialAddress,
                "bankCompanyName": bankCompanyName,
                "bankName": bankName,
                "bankIban": bankIban,
                "bankEmail": bankEmail,
            },
            {
                "disclaimerReg": disclaimerReg,
                "files": {
                    "attachmentsFiles": attachmentsFiles,
                },
                "docuSign": {
                    "url": urlPDF,
                    "content": base64,
                }
            }
        ]
        //NEW
        // let data = [
        //     {
        //         "identificator": identificator,
        //         "isShop": isShop,
        //         "products": products,
        //         "type": selectedLease,
        //         "value": productPrice,
        //         // "productPriceEnd": reconvertPrice(productPriceEnd),
        //         "price": reconvertPrice(chargePrice),
        //         "initial": reconvertPrice(initialCharge),
        //         "tax": reconvertPrice(tax),
        //         "repurchase": repurchase,
        //         "finalRate": finalRate,
        //         "rateFrequency": rateFrequency,
        //         "minMonths": minMonth,
        //         "maxMonths": maxMonth,
        //         "months": leasingTime,
        //         "selectedLeasing": activeContract,
        //         "enableModernLease": modernLease,
        //         "providerName": providerName,
        //         "providerPostal": providerPostal,
        //         "providerNip": providerNip,
        //         'callNumber': callNumber
        //     },
        //     {
        //         "nip": nip,
        //         "company": companyName,
        //         "address": companyAddress,
        //         "city": city,
        //         "postcode": postalCustomer,
        //         "additionalCompanyAddress": additionalCompanyAddress,
        //         "additionalPostalCustomer": additionalPostalCustomer,
        //         "additionalCity": additionalCity,
        //         "email": email,
        //         "emailFV": emailFV,
        //         "companyStart": companyStart,
        //         "registryType": registryType,
        //         "krs": idNumber,
        //         "phone": phone,
        //         "company_type": searchInLawForms(lawForm),
        //         "company_sector": searchInProffesions(profession),
        //         "employeesNumber": employeesNumber,
        //         "www": website,
        //         "dataFromGUS": dataFromGUS,
        //         "bank": bank,
        //         "bankAccount": bankAccount,
        //         "otherBankAccountCheckbox": otherBankAccountCheckbox,
        //         "otherBankAccount": otherBankAccount,
        //         "consentAutomaticBankAccountCheckbox": consentAutomaticBankAccountCheckbox,
        //     },
        //     {
        //         "representatives": authorizedPersons
        //     },
        //     {
        //         "taxArrears": taxArrears,
        //         "taxArrearsPrice": reconvertPrice(taxArrearsPrice),
        //         "ZUSarrears": ZUSarrears,
        //         "ZUSarrearsPrice": reconvertPrice(ZUSarrearsPrice),
        //         "enforcementProceedings": enforcementProceedings,
        //         "enforcementProceedingsPrice": reconvertPrice(enforcementProceedingsPrice),
        //         "prevTwoYearsRevenues": prevYearRevenuesTwo,
        //         "prevTwoYearsRevenueOld": reconvertPrice(revenueOldTwo),
        //         "prevTwoYearsRevenueScoreOld": revenueScoreOldTwo,
        //         "prevTwoYearsRevenueProfitOld": reconvertPrice(revenueProfitOldTwo),
        //         "prevTwoYearsRevenueLossExplanationOldTwo": revenueLossExplanationOldTwo,
        //         "prevYearRevenues": prevYearRevenues,
        //         "revenueOld": reconvertPrice(revenueOld),
        //         "revenueScoreOld": revenueScoreOld,
        //         "revenueProfitOld": reconvertPrice(revenueProfitOld),
        //         "revenueLossExplanationOld": revenueLossExplanationOld,
        //         "revenue": reconvertPrice(revenue),
        //         "revenueFrom": revenueFrom,
        //         "revenueTo": revenueTo,
        //         "revenueScore": revenueScore,
        //         "revenueProfit": reconvertPrice(revenueProfit),
        //         "revenueLossExplanation": revenueLossExplanation,
        //         "checkAndLossAmortizationOld": checkAndLossAmortizationOld, //new
        //         "checkAndLossAmortizationTypeOld": checkAndLossAmortizationTypeOld, //new
        //         "profitFromSalesOld": profitFromSalesOld, //new
        //         "checkAndLossFrom": checkAndLossFrom, //new
        //         "checkAndLossTo": checkAndLossTo, //new
        //         "checkAndLossAmortization": checkAndLossAmortization, //new
        //         "checkAndLossAmortizationTypeOldTwo": checkAndLossAmortizationTypeOldTwo, //new
        //         "profitFromSales": profitFromSales, //new
        //         "balanceFrom": balanceFrom, //new
        //         "balanceTo": balanceTo, //new
        //         "balanceFixedAssets": balanceFixedAssets, //new
        //         "balanceFixedAssetsOld": balanceFixedAssetsOld, //new
        //         "balanceTotalEquity": balanceTotalEquity, //new
        //         "balanceTotalEquityOld": balanceTotalEquityOld, //new
        //         "balanceBusinesslikeAndDurable": balanceBusinesslikeAndDurable, //new
        //         "balanceBusinesslikeAndDurableOld": balanceBusinesslikeAndDurableOld, //new
        //         "balanceCoreCapital": balanceCoreCapital, //new
        //         "balanceCoreCapitalOld": balanceCoreCapitalOld, //new
        //         "balanceAssets": balanceAssets, //new
        //         "balanceAssetsOld": balanceAssetsOld, //new
        //         "balanceLiabilitiesAndProvisions": balanceLiabilitiesAndProvisions, //new
        //         "balanceLiabilitiesAndProvisionsOld": balanceLiabilitiesAndProvisionsOld, //new
        //         "balanceWrestling": balanceWrestling, //new
        //         "balanceWrestlingOld": balanceWrestlingOld, //new
        //         "balanceLongtermLiabilities": balanceLongtermLiabilities, //new
        //         "balanceLongtermLiabilitiesOld": balanceLongtermLiabilitiesOld, //new
        //         "balanceShorttermReceivables": balanceShorttermReceivables, //new
        //         "balanceShorttermReceivablesOld": balanceShorttermReceivablesOld, //new
        //         "balanceCurrentLiabilities": balanceCurrentLiabilities, //new
        //         "balanceCurrentLiabilitiesOld": balanceCurrentLiabilitiesOld, //new
        //         "balanceCash": balanceCash, //new
        //         "balanceCashOld": balanceCashOld, //new
        //         "balanceSumOfAssetsLiabilities": balanceSumOfAssetsLiabilities, //new
        //         "balanceSumOfAssetsLiabilitiesOld": balanceSumOfAssetsLiabilitiesOld, //new
        //         "expiredStatus": expiredStatus, //new
        //         "balanceReceivables": balanceReceivables, //new
        //         "balanceObligations": balanceObligations, //new
        //         "realEstatesCorporatePrivate": realEstatesCorporatePrivate, //new
        //         "realEstatesMortgageEncumbered": realEstatesMortgageEncumbered, //new
        //         "realEstatesOwnership": realEstatesOwnership, //new
        //         "statementCreditsPaymentCheckbox": statementCreditsPaymentCheckbox, //new
        //         "receivablesObligationsDeliveriesServicesDate": receivablesObligationsDeliveriesServicesDate,
        //         "obligationsTotalPrice": obligationsTotalPrice,
        //         "obligationsLastDatePay": obligationsLastDatePay,
        //         "obligationsNumberCreditors": obligationsNumberCreditors,
        //         "obligationsOverdueLiabilities": obligationsOverdueLiabilities,
        //         "obligationsOverdueLiabilitiesOver30Days": obligationsOverdueLiabilitiesOver30Days,
        //         "receivablesTotalPrice": receivablesTotalPrice,
        //         "receivablesLastDatePay": receivablesLastDatePay,
        //         "receivablesNumberCreditors": receivablesNumberCreditors,
        //         "receivablesOverdueLiabilities": receivablesOverdueLiabilities,
        //         "receivablesOverdueLiabilitiesOver30Days": receivablesOverdueLiabilitiesOver30Days,
        //         "explanationReceivablesObligations": explanationReceivablesObligations,
        //         "explanationLoss": explanationLoss,
        //     },
        //     {
        //         "realEstatesItems": realEstatesItems,
        //         "fundsItems": fundsItems,
        //     },
        //     {
        //         "otherCreditsItems": otherCreditsItems
        //     },
        //     {
        //         "authCheckOne": authCheckOne,
        //         "authCheckOneText": "Oświadczenia Wnioskodawcy niezbędne do rozpatrzenia wniosku.WNIOSKODAWCA OŚWIADCZA, że:a) Jest upoważniony do działania w imieniu Wnioskodawcy w zakresie oświadczeń woli zawartych w niniejszym wniosku; b) Nie znajduje się w trakcie zmian organizacyjnych wymagających ich ujawnienia we właściwym rejestrze; c) Nie toczy się przeciwko niemu żadne postępowanie upadłościowe, likwidacyjne ani układowe oraz że nie znajduje się w procesie restrukturyzacji i nie jest przeciwko niemu prowadzona egzekucja skarbowa lub komornicza; d) Został poinformowany, że Administratorem danych jest GRENKELEASING Sp. z o.o., a wszystkie informacje na temat przetwarzania jego danych osobowych opisane są w Informacji o danych osobowych, stanowiącej załącznik do Wniosku; e) Wszystkie osoby fizyczne, których dane zostały zawarte we wniosku, zapoznały się z Informacją o danych osobowych, stanowiącą załącznik do wniosku; f) W przypadku udzielenia zgody na przetwarzanie danych osobowych w celach handlowo – marketingowych (numeru telefonu i/lub adresu e-mail) zgody te są rozumiane na podstawie art. 10 ust. 1 ustawy z dnia 18 lipca 2002 roku o świadczeniu usług drogą elektroniczną oraz art. 172 prawa telekomunikacyjnego.",
        //         "authName": authName,
        //         "authSurname": authSurname,
        //         "authAddress": authAddress,
        //         "authPesel": authPesel,
        //         "authId": authId,
        //         "authCheckTwo": authCheckTwo,
        //         "authCheckTwoText": "Oświadczam, że wszystkie informacje podane przeze mnie w niniejszym wniosku i załączonych do niego dokumentach są  kompletne i zgodne z prawdą i jestem świadomy /świadoma odpowiedzialności karnej, wynikającej ze składania nieprawdziwych informacji.",
        //         "authCheckThree": authCheckThree,
        //         "authCheckThreeText": "Wyrażam zgodę na otrzymywanie od GRENKE treści handlowo - marketingowych drogą elektroniczną.",
        //         "authCheckFour": authCheckFour,
        //         "authCheckFourText": "Wyrażam zgodę na otrzymywanie od GRENKE treści handlowo - marketingowych drogą telefoniczną.",
        //         "authCheckFive": authCheckFive,
        //         "authCheckFiveText": "Wyrażam zgodę na otrzymywanie od GC Faktoring treści handlowych i marketingowych drogą elektroniczną.",
        //         "authCheckSix": authCheckSix,
        //         "authcheckSixText": "Wyrażam zgodę na otrzymywanie od GC Faktoring treści handlowych i marketingowych drogą telefoniczną.",
        //         // "authCheckSeven": authCheckSeven,
        //         // "authCheckEight": authCheckEight,
        //         "comments": comments,
        //         "postman": postman,
        //         "emailInvoice": emailFV,
        //         "esign": esign,
        //         "esignPersons": esignPersons
        //     },
        //     {
        //         "files": {
        //             "realEstatesFiles": realEstatesFiles,
        //             "fundsFiles": fundsFiles,                      
        //             "otherCreditsFiles": otherCreditsFiles,
        //             "attachmentsFiles": attachmentsFiles,
        //             'fvFile': fvFile
        //         }
        //     }

        // ]
        // console.log(data)
        let companyDateSplit = companyStart.length > 0 ? companyStart.split('-') : ["","",""];
        let dataPDF = [
            {
                productPrice: productPrice,
                companyInfo: `${companyName}\n${postalCustomer} ${city} ${companyAddress}`,
                companyPhone: phone,
                companyWWW: website,
                companyEmail: email,
                emailFV: emailFV.length == 0 ? '': emailFV,
                companyCreatedDate: {
                    day: companyDateSplit[2],
                    month: companyDateSplit[1],
                    year: companyDateSplit[0],
                },
                employeesNumber: employeesNumber,
                additionalPostal: additionalPostalCustomer.length == 0 ? '': additionalPostalCustomer,
                additionalCity: additionalCity.length == 0 ? '': additionalCity,
                additionalAddress: additionalCompanyAddress.length == 0 ? '': additionalCompanyAddress,
                profession: profession,
                krs: idNumber,
                nip: nip,
                emailInvoice: emailFV.length == 0 ? '': emailFV,
                representatives: authorizedPersons,
                taxArrears: taxArrears,
                taxArrearsPrice: reconvertPrice(taxArrearsPrice),
                ZUSarrears: ZUSarrears,
                ZUSarrearsPrice: reconvertPrice(ZUSarrearsPrice),
                enforcementProceedings: enforcementProceedings,
                enforcementProceedingsPrice: reconvertPrice(enforcementProceedingsPrice),
                prevYearRevenuesTwo: prevYearRevenuesTwo,
                revenueOldTwo: reconvertPrice(revenueOldTwo),
                revenueScoreOldTwo: revenueScoreOldTwo,
                revenueProfitOldTwo: reconvertPrice(revenueProfitOldTwo),
                revenueLossExplanationOldTwo: revenueLossExplanationOldTwo,
                prevYearRevenues: prevYearRevenues,
                revenue: reconvertPrice(revenue),
                revenueOld: reconvertPrice(revenueOld),
                revenueScoreOld: revenueScoreOld,
                revenueProfitOld: reconvertPrice(revenueProfitOld),
                revenueLossExplanationOld: revenueLossExplanationOld,
                revenueFrom: getNumberMonth(revenueFrom),
                revenueTo: getNumberMonth(revenueTo),
                revenueScore: revenueScore,
                revenueProfit: reconvertPrice(revenueProfit),
                revenueLossExplanation: revenueLossExplanation,
                checkAndLossAmortizationOld: checkAndLossAmortizationOld,
                checkAndLossAmortizationTypeOld: checkAndLossAmortizationTypeOld,
                profitFromSalesOld: profitFromSalesOld,
                checkAndLossFrom: getNumberMonth(checkAndLossFrom),
                checkAndLossTo: getNumberMonth(checkAndLossTo),
                checkAndLossAmortization: checkAndLossAmortization,
                checkAndLossAmortizationTypeOldTwo: checkAndLossAmortizationTypeOldTwo,
                profitFromSales: profitFromSales,
                balanceFrom: getNumberMonth(balanceFrom),
                balanceTo: getNumberMonth(balanceTo),
                balanceFixedAssets: balanceFixedAssets,
                balanceFixedAssetsOld: balanceFixedAssetsOld,
                balanceTotalEquity: balanceTotalEquity,
                balanceTotalEquityOld: balanceTotalEquityOld,
                balanceBusinesslikeAndDurable: balanceBusinesslikeAndDurable,
                balanceBusinesslikeAndDurableOld: balanceBusinesslikeAndDurableOld,
                balanceCoreCapital: balanceCoreCapital,
                balanceCoreCapitalOld: balanceCoreCapitalOld,
                balanceAssets: balanceAssets,
                balanceAssetsOld: balanceAssetsOld,
                balanceLiabilitiesAndProvisions: balanceLiabilitiesAndProvisions,
                balanceLiabilitiesAndProvisionsOld: balanceLiabilitiesAndProvisionsOld,
                balanceWrestling: balanceWrestling,
                balanceWrestlingOld: balanceWrestlingOld,
                balanceLongtermLiabilities: balanceLongtermLiabilities,
                balanceLongtermLiabilitiesOld: balanceLongtermLiabilitiesOld,
                balanceShorttermReceivables: balanceShorttermReceivables,
                balanceShorttermReceivablesOld: balanceShorttermReceivablesOld,
                balanceCurrentLiabilities: balanceCurrentLiabilities,
                balanceCurrentLiabilitiesOld: balanceCurrentLiabilitiesOld,
                balanceCash: balanceCash,
                balanceCashOld: balanceCashOld,
                balanceSumOfAssetsLiabilities: balanceSumOfAssetsLiabilities,
                balanceSumOfAssetsLiabilitiesOld: balanceSumOfAssetsLiabilitiesOld,
                realEstatesItems: realEstatesItems,
                fundsItems: fundsItems,
                otherCreditsItems: otherCreditsItems,
                consentAutomaticBankAccountCheckbox: consentAutomaticBankAccountCheckbox,
                expiredStatus: expiredStatus,
                balanceObligations: balanceObligations,
                balanceReceivables: balanceReceivables,
                realEstatesCorporatePrivate: realEstatesCorporatePrivate,
                realEstatesMortgageEncumbered: realEstatesMortgageEncumbered,
                realEstatesOwnership: realEstatesOwnership,
                statementCreditsPaymentCheckbox: statementCreditsPaymentCheckbox,
                authCheckOne: authCheckOne,
                authCheckTwo: authCheckTwo,
                authCheckThree: authCheckThree,
                authCheckFour: authCheckFour,
                authCheckFive: authCheckFive,
                authCheckSix: authCheckSix,
                receivablesObligationsDeliveriesServicesDate: receivablesObligationsDeliveriesServicesDate,
                obligationsTotalPrice: obligationsTotalPrice,
                obligationsLastDatePay: obligationsLastDatePay,
                obligationsNumberCreditors: obligationsNumberCreditors,
                obligationsOverdueLiabilities: obligationsOverdueLiabilities,
                obligationsOverdueLiabilitiesOver30Days: obligationsOverdueLiabilitiesOver30Days,
                receivablesTotalPrice: receivablesTotalPrice,
                receivablesLastDatePay: receivablesLastDatePay,
                receivablesNumberCreditors: receivablesNumberCreditors,
                receivablesOverdueLiabilities: receivablesOverdueLiabilities,
                receivablesOverdueLiabilitiesOver30Days: receivablesOverdueLiabilitiesOver30Days,
                explanationReceivablesObligations: explanationReceivablesObligations,
                explanationLoss: explanationLoss,
                registryType: registryType,
            }
        ]
        //END NEW
        // let data = [];
        req.open('POST', `${ getApiLink() }/finishForm.php`);
        req.setRequestHeader("Content-Type", "application/json;charset=UTF-8"); 
        req.send(JSON.stringify(data));
        req.addEventListener("readystatechange", async function () {
            if (this.readyState === 4) {
                // let dataPDF = {
                //     "productPrice": "2252222.00",
                //     "companyInfo": "ORANGE POLSKA SPÓŁKA AKCYJNA\n02-326 london 22 Birkbeck Avenue Greenford",
                //     "companyPhone": "07898112269",
                //     "companyWWW": "www.norddigital.pl",
                //     "companyEmail": "kontakt@wp.pl",
                //     "emailFV": "faktura@wp.pl",
                //     "companyCreatedDate": {
                //         "day": "17",
                //         "month": "01",
                //         "year": "1992"
                //     },
                //     "employeesNumber": "10",
                //     "additionalPostal": "additionalPostal",
                //     "additionalCity": "additionalCity",
                //     "additionalAddress": "additionalAddress",
                //     "profession": "profession",
                //     "krs": "krs",
                //     "nip": "nip",
                //     "emailInvoice": "faktura@wp.pl",
                //     "registryType": "CEIDG",
                //     "representatives": [
                //         {
                //             "name": "Dawid",
                //             "surname": "Dobrzyński",
                //             "pesel": "94081503950",
                //             "id": "seriainumer123",
                //             "document": "Dowód osobisty",
                //             "countryBirth": "Polska",
                //             "citizenship": "Polskie",
                //             "citizenship2Status": false,
                //             "citizenship2": "",
                //             "authorizationEcontract": false,
                //             "authorizationEmail": "",
                //             "authorizationPhone": "",
                //             "idReleaseDate": "2024-05-01",
                //             "idExpirationDate": "2024-05-31",
                //             "address": "adres",
                //             "maritalStatus": "Współmałżonek — wspólnota majątkowa",
                //             "phone": "",
                //             "email": ""
                //         },
                //         {
                //             "name": "Jan",
                //             "surname": "Bąk",
                //             "pesel": "94081503950",
                //             "document": "Inny (np. karta pobytu)",
                //             "countryBirth": "Albania",
                //             "citizenship": "Afgańskie",
                //             "citizenship2Status": false,
                //             "citizenship2": "",
                //             "authorizationEcontract": false,
                //             "authorizationEmail": "",
                //             "authorizationPhone": "",
                //             "id": "seriainumerdok2",
                //             "idReleaseDate": "2024-05-02",
                //             "idExpirationDate": "2024-05-30",
                //             "address": "",
                //             "maritalStatus": "Współmałżonek — rodzielność majątkowa"
                //         }
                //     ],
                //     "taxArrears": "Tak",
                //     "taxArrearsPrice": "1.00",
                //     "ZUSarrears": "Tak",
                //     "ZUSarrearsPrice": "2.00",
                //     "enforcementProceedings": "Tak",
                //     "enforcementProceedingsPrice": "3.00",
                //     "prevYearRevenuesTwo": "",
                //     "revenueOldTwo": "2323.00",
                //     "revenueScoreOldTwo": "Zysk",
                //     "revenueProfitOldTwo": "2.00",
                //     "revenueLossExplanationOldTwo": "",
                //     "prevYearRevenues": "",
                //     "revenue": "234.00",
                //     "revenueOld": "32423.00",
                //     "revenueScoreOld": "Strata",
                //     "revenueProfitOld": "234.00",
                //     "revenueLossExplanationOld": "wyjaśnienie",
                //     "revenueFrom": "01",
                //     "revenueTo": "03",
                //     "revenueScore": "Zysk",
                //     "revenueProfit": "1.00",
                //     "revenueLossExplanation": "",
                //     "checkAndLossAmortizationOld": "1,00",
                //     "checkAndLossAmortizationTypeOld": "Zysk",
                //     "profitFromSalesOld": "1,00",
                //     "checkAndLossFrom": getNumberMonth("Styczeń"),
                //     "checkAndLossTo": getNumberMonth("Kwiecień"),
                //     "checkAndLossAmortization": "222,00",
                //     "checkAndLossAmortizationTypeOldTwo": "Zysk",
                //     "profitFromSales": "22,00",
                //     "balanceFrom": getNumberMonth("Styczeń"),
                //     "balanceTo": getNumberMonth("Styczeń"),
                //     "balanceFixedAssets": "1,00",
                //     "balanceFixedAssetsOld": "13,00",
                //     "balanceTotalEquity": "2,00",
                //     "balanceTotalEquityOld": "14,00",
                //     "balanceBusinesslikeAndDurable": "3,00",
                //     "balanceBusinesslikeAndDurableOld": "15,00",
                //     "balanceCoreCapital": "4,00",
                //     "balanceCoreCapitalOld": "16,00",
                //     "balanceAssets": "5,00",
                //     "balanceAssetsOld": "17,00",
                //     "balanceLiabilitiesAndProvisions": "6,00",
                //     "balanceLiabilitiesAndProvisionsOld": "18,00",
                //     "balanceWrestling": "7,00",
                //     "balanceWrestlingOld": "19,00",
                //     "balanceLongtermLiabilities": "8,00",
                //     "balanceLongtermLiabilitiesOld": "20,00",
                //     "balanceShorttermReceivables": "9,00",
                //     "balanceShorttermReceivablesOld": "21,00",
                //     "balanceCurrentLiabilities": "10,00",
                //     "balanceCurrentLiabilitiesOld": "22,00",
                //     "balanceCash": "11,00",
                //     "balanceCashOld": "23,00",
                //     "balanceSumOfAssetsLiabilities": "12,00",
                //     "balanceSumOfAssetsLiabilitiesOld": "24,00",
                //     "realEstatesItems": [
                //         {
                //             "name": 'DOMEK',
                //             "address": 'adres',
                //             "price": '123456',
                //             "credit": 'Tak',
                //             "property": 'Firmy',
                //             "kw": 'kw',
                //         },
                //         {
                //             "name": 'MIESZKANIE',
                //             "address": 'adres2',
                //             "price": '12222',
                //             "credit": 'Tak',
                //             "property": 'Prywatna',
                //             "kw": 'kw',
                //         },
                //     ],
                //     "fundsItems": [],
                //     "otherCreditsItems": [
                //         {
                //             "typeCredit": "Kredyt",
                //             "descCredit": "rata tel",
                //             "priceToEnd": "111 111,00",
                //             "creditStartDate": "1994",
                //             "creditEndDay": "1100"
                //         },
                //         {
                //             "typeCredit": "Leasing",
                //             "descCredit": "rata tel2",
                //             "priceToEnd": "211 111,00",
                //             "creditStartDate": "2994",
                //             "creditEndDay": "2100"
                //         },
                //         {
                //             "typeCredit": "Inne",
                //             "descCredit": "rata tel3",
                //             "priceToEnd": "311 111,00",
                //             "creditStartDate": "3994",
                //             "creditEndDay": "3100"
                //         }
                //     ],
                //     "consentAutomaticBankAccountCheckbox": false,
                //     "expiredStatus": "Tak",
                //     "balanceObligations": "33,00",
                //     "balanceReceivables": "22,00",
                //     "realEstatesCorporatePrivate": "Tak",
                //     "realEstatesMortgageEncumbered": "Tak",
                //     "realEstatesOwnership": "Prywatna",
                //     "statementCreditsPaymentCheckbox": "Tak",
                //     "authCheckOne": true,
                //     "authCheckTwo": true,
                //     "authCheckThree": true,
                //     "authCheckFour": true,
                //     "authCheckFive": false,
                //     "authCheckSix": true,
                //     "receivablesObligationsDeliveriesServicesDate": "2024-05-09",
                //     "obligationsTotalPrice": "12,00",
                //     "obligationsLastDatePay": "2024-05-09",
                //     "obligationsNumberCreditors": "3",
                //     "obligationsOverdueLiabilities": "12,00",
                //     "obligationsOverdueLiabilitiesOver30Days": "15,00",
                //     "receivablesTotalPrice": "15,00",
                //     "receivablesLastDatePay": "2024-05-09",
                //     "receivablesNumberCreditors": "1",
                //     "receivablesOverdueLiabilities": "15,00",
                //     "receivablesOverdueLiabilitiesOver30Days": "17,00",
                //     "explanationReceivablesObligations": "pandemia to przyczyna",
                //     "explanationLoss": "ciezki czas po pandemii",
                // }
                // console.log(dataPDF)
                // if(productPrice > 50000) {
                //     // let savePDF = drawPDF(dataPDF[0]);
                //     // if(savePDF) {
                //         await wait(2000);
                //         await setButtonText('Złóż wniosek');
                //         await setFinishLoading( false );
                //         await setModal( false );
                //         if(req.response) {
                //             await window.open(req.response,"_self");
                //         }
                //     // }
                // }else{
                //     await setButtonText('Złóż wniosek');
                //     await setFinishLoading( false );
                //     await setModal( false );
                //     if(req.response) {
                //         await window.open(req.response,"_self");
                //     }
                // }


                if(req.response && req.response == "sendsend") {
                    await navigate('/thank-you');
                }

            }
        });
    }
    let saveAttachments = () => {
        let fdata = new FormData()
        let files = [];
        if ( attachmentsFiles.length > 0 ) {
            attachmentsFiles.map(item => {
                files.push(item);
            })
        }
        files.map((item, index) => {
            fdata.append('files'+index, item.file);
            fdata.append('files'+index+'type', item.title);
        })
        fdata.append('id', (identificator == '' ? 'Testowy folder' : identificator));
        let req = new XMLHttpRequest();
        req.open('POST', `${ getApiLink() }/saveAttachments.php`);
        req.send(fdata);
    
        req.addEventListener("readystatechange", async function () {
            if (this.readyState === 4) {
                await saveForm();
            }
        });
    }

    async function wait(ms) {
        return new Promise(resolve => {
          setTimeout(resolve, ms);
        });
    }

    let checkErrors = () => {
        let result;
        let elements = document.querySelectorAll('.error-item');

        if( elements.length > 0 ) {
            result = true;
            window.scroll({
                behavior: 'smooth',
                left: 0,
                top: elements[0].offsetTop - 185
            });
        } else {
            result = false;
        }
        return result;
        
    }

    let recalculateRates = () => {

        let valuePrice = productPrice;
            valuePrice = valuePrice.replace(/ /g,'');
            valuePrice = valuePrice.replace('zł', '');
            valuePrice = valuePrice.replace(',','.');
        
        let valueTax = tax;
            valueTax = valueTax.replace(/ /g,'');
            valueTax = valueTax.replace('zł', '');
            valueTax = valueTax.replace(',','.');

        let valueInitial = initialCharge;
            valueInitial = valueInitial.replace(/ /g,'');
            valueInitial = valueInitial.replace('zł', '');
            valueInitial = valueInitial.replace(',','.');
            valueInitial = valueInitial.replace('%','');

        let req = new XMLHttpRequest();
        let data = {
            "type": activeContract,
            "value": valuePrice,
            "price": valueTax,
            "initial": valueInitial,
            "months": leasingTime,
            "products": products
        }
        if ( (window.AppConfig || window.location.hostname === 'localhost') && parseInt(productPrice) > 0) {
            req.open('POST', `${ getApiLink() }/calculate.php`);
            req.setRequestHeader("Content-Type", "application/json;charset=UTF-8"); 
            req.send(JSON.stringify(data));
            
            req.addEventListener("readystatechange", async function () {
            if (this.readyState === 4) {
                let resp = JSON.parse(req.response);
                    if ( resp != 'error') {
                        if ( resp.result.month == '--' || resp.result.quater == '--' ) {
                            dispatch({ type: 'TAX_CHANGE', value: '0,00 AED'})
                            if ( rateFrequency === 'kwartalnie' ){
                                dispatch({ type: 'FINAL_RATE_CHANGE', value: '0,00 zł' })
                            }
                            if ( rateFrequency === 'miesięcznie' ){
                                dispatch({ type: 'FINAL_RATE_CHANGE', value: '0,00 zł' })
                            }
                            dispatch({ type: 'REPURCHASE_CHANGE', value: 0.00 }); 
                        } else {
                            dispatch({ type: 'TAX_CHANGE', value: convertPrice(resp.result.price.toFixed(2) ) + " AED"})
                            if ( rateFrequency === 'kwartalnie' ){
                                dispatch({ type: 'FINAL_RATE_CHANGE', value: resp.result.quater })
                            }
                            if ( rateFrequency === 'miesięcznie' ){
                                dispatch({ type: 'FINAL_RATE_CHANGE', value: resp.result.month })
                            }
                            dispatch({ type: 'REPURCHASE_CHANGE', value: parseFloat(resp.result.repurchase).toFixed(2) });              
                        }
                        
                    }
                }
            });
        }
        
    }

    const finish = async() => {
        await setFinishLoading( true );
        if( !finishLoading ) {
            await setButtonText('Twój wniosek jest przetwarzany...')
            await wait(400);
            if ( !(finalRate.length == 0 || finalRate == 0 || finalRate == '--' || finalRate == '0 zł') ) {
                await saveAttachments();
            } else {
                await getTextBtn();
                await setFinishLoading( false );
            }
            // await saveAttachments();
        }
    }

    return (
        <>
        {modal &&
            <ModalLastStep closeModal={() => setModal(false)} setFunction={() => finish()} finishLoading={finishLoading} btnText={buttonText} productPrice={productPrice} />
        }
        <section className="form steps">
            <div className="container">
                <div className="row" >
                    <Heading title="Summary"
                        class={ "more-margin-bottom" }
                        borderBottom
                        tip={ false } 
                        tipHeader="Liczba pracowników"
                        tipText="Wpisz łączną liczbę pracowników, niezależnie od formy zatrudnienia. W przypadku działalności jednoosobowej bez osób zatrudnionych, wpisz 0." />
                    <LeasingRateResult forceValidate={ forceValidate } />
                    {/* <Authorizations forceValidate={ forceValidate } /> */}
                </div>
                <div className="row attachments-row">
                    <Attachments forceValidate={ forceValidate } />
                </div>

                {/* <ButtonsNav bg nextBlack prev={() => prev()} next={() => next()} classNext={(finishLoading ? ' loading black' : ' black')} titleNext="Send the form" /> */}
                <ButtonsNav bg nextBlack prev={() => prev()} next={() => next()} classNext={(finishLoading ? ' loading' : '')} titleNext="Send the form" />

            </div>
        </section>
        </>
    )
}

export default StepSix;